import React, { useContext, useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import moment from "moment";
import findBrand from "../findBrand";
import { getsites, getMainDomainNew, loadBrands } from "../findBrand";
import queryString from "query-string";
import { toast } from "react-toastify";


import ProgressButtons from "./ProgressButtons";
import InterestContext from "../../context/interest/interestContext";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";
import { californiaZips } from "../../data/californiaZipCodes";
import countriesList from "../../data/countriesList";
import states from "../../data/states";
import { brandDomains } from "../brand";
import { getLocationApiUrl } from "../../functions/getEnv";

const InitialQuestions = () => {
  const interestContext = useContext(InterestContext);
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const authContext = useContext(AuthContext);
  const [showCompleteMessage, setShowCompleteMessage] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [birth, setBirth] = useState(false);
  const hostname = "enrollments.learn4life.org"

  const { setFormModal, sendOrientationEmail } = adminRegistrationContext;
  const { user } = authContext;    

  const {
    formData: {
      studentFirstName,
      studentLastName,
      currentGradeLevel,
      birthDate,
      parentRelationship,
      parentFirstName,
      parentLastName,
      primaryEmail,
      phone,
      street1,
      street2,
      country,
      state,
      region,
      zipCode,
      city,
      sameAddress,
      mailingStreet1,
      mailingStreet2,
      mailingCountry,
      mailingState,
      mailingRegion,
      mailingZipCode,
      mailingCity,
      _uuid,
      learningCenterId,
    },
    formData,
    age,
    getAge,
    onFormDataChange,
    pass: { initial },
    getDomanName,
    domanName,
    submitDataPublic,
    sendInterestEmail,
    zipSearch,
    getSiteprogram,
    Siteprogram
  } = interestContext;

  // Get siteId from URL parameters FIRST
  const urlParams = new URLSearchParams(window.location.search);
  const siteId = urlParams.get('site') || "";

  // Get brandName and siteId (similar to your EnrollmentInterestPage)
  // const brandName = getsites();
  const [brandName, setBrandName] = useState(null);
  const [mainDomain, setMainDomain] = useState(null);
  const [siteDataLoaded, setSiteDataLoaded] = useState(!siteId); // If no siteId, consider loaded
  

  // Function to determine current brand
  const getCurrentBrand = () => {
    const currentUrl = window.location.hostname.toLowerCase();

    // Check if brandDomains is available and get Learn4Life domain
    const learn4lifeDomain = brandDomains?.brand_learn4life?.name?.toLowerCase();

    if (learn4lifeDomain && currentUrl.includes(learn4lifeDomain)) {
      return "learn4life";
    }

    // Fallback: check against domanName from context if available
    if (domanName === "learn4life") {
      return "learn4life";
    }

    // Additional fallback: check URL for learn4life keywords
    if (currentUrl.includes("learn4life")) {
      return "learn4life";
    }

    return "other";
  };

  // Get the background color based on brand
  const getBackgroundColor = () => {
    const currentBrand = getCurrentBrand();
    return currentBrand === "learn4life" ? "#F7F3EC" : "#ffffff";
  };

  // Validation functions
  const validateBirthday = (age) => {
    // Returns true if age is INVALID (outside 1-70 range)
    return age < 4 || age > 50;
  };

  const calculateAge = (birthDate) => {
    const birthDateObj = new Date(birthDate);
    if (isNaN(birthDateObj)) {
      console.error("Invalid birthDate:", birthDate);
      return 0;
    }
    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }

    return age;
  };

  const validateEmail = (email) => {
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const re = /^[^.#]+([a-zA-Z[0-9.!$%&'*+/=?^_`{|}~-]+)[^-#\.]@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;
    return re.test(String(email).toLowerCase()) && reg.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  const validatezipCode = (e) => {
    const re = /^\d{5}$/;
    return re.test(String(e).toLowerCase());
  };

  // Form validation - include site data loading check
  const isFormValid =
    studentFirstName !== "" &&
    studentLastName !== "" &&
    birthDate !== "" &&
    !validateBirthday(age) &&
    (age >= 18 || (parentRelationship !== "" && parentFirstName !== "" && parentLastName !== "")) &&
    primaryEmail !== "" &&
    validateEmail(primaryEmail) &&
    phone !== "" &&
    validatePhone(phone) &&
    zipCode !== "" &&
    validatezipCode(zipCode) &&
    siteDataLoaded; // Ensure site data is loaded before allowing submission

  // Function to get border style based on submit attempt and field value
  const getBorderStyle = (fieldValue, isRequired = true, isDate = false) => {
    // If submit hasn't been attempted yet, show normal border
    if (!submitAttempted) {
      return "2px solid #ccc";
    }

    // If submit attempted and field is required and empty, show red border
    if (isRequired && (!fieldValue || fieldValue === "")) {
      return "2px solid #d8302f";
    }

    if (isDate && fieldValue && !validateBirthday(fieldValue)) {
      return "2px solid #d8302f";
    }

    // Otherwise show normal border
    return "2px solid #ccc";
  };

  // Event handlers
  const formatPhoneNumber = (evt) => {
    const regex = /^\+?[0-9-]+$/;
    if (evt.target.value === "" || regex.test(evt.target.value)) {
      var aVal = evt.target.value;
      aVal = aVal.replace(/\\D/g, "").replace(/ /g, "").replace(/\-/g, "").replace(/\(/g, "").replace(/\)/g, "");
      if (aVal.length >= 10 && aVal.charAt(0) == "1")
        aVal = aVal.replace("-", "").replace("-", "");
      if (aVal.length > 0) {
        if (aVal.length > 8) {
          aVal = aVal.substring(0, 3) + "-" + aVal.substring(3, 6) + "-" + aVal.substring(6, 10);
          evt.target.value = aVal;
        } else if (aVal.length == 7) {
          aVal = aVal.substring(0, 3) + "-" + aVal.substring(3, 7);
          evt.target.value = aVal;
        }
      }
      onFormDataChange(evt);
    }
  };

  const handleZipChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 5);
    e.target.value = value;
    onFormDataChange(e);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const handleChangeLastName = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const intialFilledOut = isFormValid;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);



  // Form submission
  const onSubmit = async (e) => {
    setSubmitAttempted(true);
    
    e.preventDefault();

    if (isFormValid) {
      // Get site parameter if it exists
      const urlParams = new URLSearchParams(window.location.search);
      const siteParam = urlParams.get('site');

    
      // UUID generation function
      const generateRealUUID = () => {
        if (crypto && crypto.randomUUID) {
          return crypto.randomUUID();
        }

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      };

      // Use existing UUID from formData if available (from copy enrollment link), otherwise generate new one
      const uuidToUse = _uuid || generateRealUUID();
     // console.log('UUID being used:', uuidToUse, '- Source:', _uuid ? 'Existing (Copy Enrollment Link)' : 'Newly Generated');
      //Learning center data - populate from site program if available
      let learningCenterData = {
        learningCenterId: siteParam || '0',
        learningCenterName: '',
        learningCenterCharter: '',
        learningCenterAddress: '',
      };

      // If we have site program data, extract learning center information
      if (Siteprogram && siteParam) {
        // Find primary address using comprehensive logic
        let primaryAddress = null;
        
        // Step 1: Check if main address is marked as primary
        if (Siteprogram.address && Siteprogram.address.isPrimary === true) {
          primaryAddress = Siteprogram.address;
        }
        
        // Step 2: If no primary main address, check addresses array for primary
        if (!primaryAddress && Siteprogram.addresses && Siteprogram.addresses.length > 0) {
          primaryAddress = Siteprogram.addresses.find(addr => addr.isPrimary === true);
        }
        
        // Step 3: If no primary address found anywhere, use main address as fallback
        if (!primaryAddress && Siteprogram.address) {
          primaryAddress = Siteprogram.address;
        }
        
        // Step 4: If still no address, use first address from array
        if (!primaryAddress && Siteprogram.addresses && Siteprogram.addresses.length > 0) {
          primaryAddress = Siteprogram.addresses[0];
        }

        // Format the address
        const formattedAddress = primaryAddress 
          ? `${primaryAddress.address_1 || ''} ${primaryAddress.city || ''} ${primaryAddress.state || ''}`.trim()
          : '';

        // Debug logging
        // console.log('Interest Form Address Debug:', {
        //   siteId: siteParam,
        //   siteName: Siteprogram.name,
        //   hasMainAddress: !!Siteprogram.address,
        //   mainAddressIsPrimary: Siteprogram.address?.isPrimary,
        //   addressesCount: Siteprogram.addresses?.length || 0,
        //   primaryAddressesCount: Siteprogram.addresses?.filter(addr => addr.isPrimary === true)?.length || 0,
        //   selectedAddress: primaryAddress ? {
        //     address_1: primaryAddress.address_1,
        //     city: primaryAddress.city,
        //     state: primaryAddress.state,
        //     isPrimary: primaryAddress.isPrimary,
        //     source: primaryAddress === Siteprogram.address ? 'main' : 'array'
        //   } : null,
        //   formattedAddress: formattedAddress
        // });

        learningCenterData = {
          learningCenterId: siteParam,
          learningCenterName: Siteprogram.name || '',
          learningCenterCharter: Siteprogram.charter?.name || '',
          learningCenterAddress: formattedAddress,
        };
      }

      //FIXED: Initialize siteData with default values to ensure fields are always present
      let siteData = {
        charterWebsite: "",
        charterContactnumber: "",
        brandIcon: "",
        principal: "",
        lastContactDate: new Date().toISOString(),
      };

      // Populate site data from Siteprogram if available
      if (Siteprogram && siteParam) {
        siteData = {
          charterWebsite: Siteprogram.charter?.charterWebsite || "",
          charterContactnumber: Siteprogram.charter?.charterContactnumber || Siteprogram.address?.phone || "",
          brandIcon: Siteprogram.charter?.brandIcon || "",
          principal: "", // Add principal logic if needed
          lastContactDate: new Date().toISOString(),
        };
      }
     

      //FIXED: Always include complete data in submission
      const completeSubmissionData = {
        ...formData,                           // All form fields
        ...learningCenterData,                 // Learning center data (includes learningCenterId)
        ...siteData,                          // Site data (includes ALL fields with defaults)
        age,                                   // Calculated age
        _uuid: uuidToUse,                      // Use existing UUID or newly generated one
        submissionType: 'interest',
        enrollstatus: 'No',
        brandName:brandName,
        hasCharterPreselection: !!siteParam,
        submittedAt: new Date().toISOString(),
      };

      //Submit complete data to database and get the returned _uuid
      const interestRecordId = await submitDataPublic(completeSubmissionData);

      if (!Siteprogram || !Siteprogram.enrollment_info) {
        console.log('No site program data available, defaulting to send email');
       // sendInterestEmail(completeSubmissionData, interestRecordId);
      } else {
        const { primaryEmailstatus, addtionalEmailstatus, interestEmail } = Siteprogram.enrollment_info;

        //console.log('Email status check:', { primaryEmailstatus, addtionalEmailstatus, interestEmail });

        // Send email to primary email (student's email) if primaryEmailstatus is "Yes"
        if (primaryEmailstatus === "Yes") {
         // console.log('Sending email to primary email (student):', completeSubmissionData.primaryEmail);
          sendInterestEmail(completeSubmissionData, interestRecordId);
        }

        // Send email to additional emails (interest emails) if addtionalEmailstatus is "Yes"
        if (addtionalEmailstatus === "Yes" && interestEmail && Array.isArray(interestEmail) && interestEmail.length > 0) {
         // console.log('Sending emails to interest email addresses:', interestEmail);

          // Send email to each interest email address
          interestEmail.forEach((email, index) => {
            if (email && email.trim()) { // Check if email is valid and not empty
              //console.log(`Sending email to interest email ${index + 1}:`, email);

              // Create a modified data object with the interest email as the recipient
              const interestEmailData = {
                ...completeSubmissionData,
                primaryEmail: email.trim(), // Replace primaryEmail with the interest email
              };

              sendInterestEmail(interestEmailData, interestRecordId);
            }
          });
        }

        // Log if no emails should be sent
        if (primaryEmailstatus === "No" && addtionalEmailstatus === "No") {
          console.log('No emails will be sent - both primaryEmailstatus and addtionalEmailstatus are "No"');
        }
      }



      setShowCompleteMessage(true);
      toast.success("Form submitted successfully!");
    }
    else {
      toast.error("Please fill all requried fields");
    }
  };

  useEffect(() => {
    const loadBrandsAndSetDomain = async () => {
      try {
        // Ensure brands are loaded
        await loadBrands();

        // Get the main domain after brands are loaded
        const domain = getMainDomainNew();
        setMainDomain(domain);

        // Get the brand name
        const brand = getsites();
        setBrandName(brand);
        
        // Load site program data if siteId exists
        if (siteId) {
          getSiteprogram(siteId);
        }

        //  console.log("Main Domain:", domain);
        //console.log("Brand Name:", brand);
      } catch (error) {
        console.error("Error loading brands:", error);
        // Set fallback values
        setMainDomain(false);
        setBrandName(false);
      }
    };

    loadBrandsAndSetDomain();
  }, []);

  // Watch for Siteprogram data to be loaded
  useEffect(() => {
    if (siteId && Siteprogram && Siteprogram._id) {
      setSiteDataLoaded(true);
      // console.log('Site program data received:', {
      //   siteId: siteId,
      //   siteName: Siteprogram.name,
      //   hasAddress: !!Siteprogram.address,
      //   hasAddresses: !!(Siteprogram.addresses && Siteprogram.addresses.length > 0)
      // });
    }
  }, [Siteprogram, siteId]);

  return (
    <React.Fragment>
      <form onSubmit={onSubmit}>
        {/* Show validation message ABOVE when submit attempted and form invalid */}
        {submitAttempted && !isFormValid && (
          // <div style={{
          //   padding: "15px",
          //   marginBottom: "-10px",
          //   textAlign: "center",
          // }}>
          //   <p style={{
          //     color: "#d8302f",
          //     fontWeight: "bold",
          //     fontSize: "18px",
          //     margin: "0"
          //   }}>
          <div className="validation-message-container">
            <p className="validation-message-text">
            
            </p>
          </div>
        )}

        <div className={`sub-form1 ${brandName === "learn4life" ? 'learn4life-form' : ''}`}>
          {/* Learn4Life Header - Now inside the form box with same styling as items */}
          {brandName === "learn4life" && (
            <div className="learn4life-header item">
             
              <p className="learn4life-title">
                <strong>Curious about Learn4Life?</strong>
              </p>
              <p className="learn4life-subtitle">We've got you covered.</p>

              <p className="learn4life-intro">
                If you're exploring school options and want to learn more about Learn4Life before enrolling, our
                free digital Info Kit is a great place to start.
              </p>

              <div className="learn4life-whats-inside">
                <h3 className="learn4life-section-title">
                  <strong>What's inside?</strong>
                </h3>
                <ul className="learn4life-features-list">
                  <li>How our flexible learning model works</li>
                  <li>Programs and student support</li>
                  <li>Real student stories</li>
                  <li>FAQs for parents</li>
                </ul>
              </div>

              <div className="learn4life-next-steps">
                <h3 className="learn4life-section-title">
                  <strong>Next steps:</strong>
                </h3>
                <p>
                  Just fill out the short form below and we'll email the Info Kit right to you. No pressure—just the
                  info you need to make the best choice for your student.
                </p>
              </div>
              <div className="learn4life-ready-message">                
                <p>
                  We're here when you're ready!
                </p>
              </div>
            </div>
          )}

            <h3 className="student-info-title">Student Information</h3>

          {!initial && (
            <p className="validation-msg">Please Fill All The Required Fields</p>
          )}

          <div className="item">
            <div className="asterisk-group">
              <h3 >What is the Student's First Name?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="50"
              autoCapitalize="0"
              name="studentFirstName"
              value={studentFirstName}
              onChange={(e) => onFormDataChange(e)}
              className={`form-input ${submitAttempted && !studentFirstName ? 'error-border' : 'normal-border'}`}

            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>{`What is ${studentFirstName === "" ? "the Student" : studentFirstName
                }'s Last Name?`}</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="50"
              autoCapitalize="0"
              name="studentLastName"
              onChange={(e) => onFormDataChange(e)}
              value={studentLastName}
              className={`form-input ${submitAttempted && !studentLastName ? 'error-border' : 'normal-border'}`} 
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>{`What is ${studentFirstName === "" ? "the Student" : studentFirstName
                }'s Date of Birth?`}</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="date"
              name="birthDate"
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => {
                onFormDataChange(e);
                getAge(moment(e.target.value).utc());
              }}
              value={birthDate}
              className={`form-input ${submitAttempted && !birthDate ? 'error-border' : 'normal-border'}`}

            />
            {/* Invalid age (less than 0 or more than 100) */}
            {birthDate && (age < 0 || age > 100) && (
              <p className="validEmail">Invalid age. Please enter a valid date of birth.</p>
            )}

            {/* Age less than 4 */}
            {birthDate && age >= 0 && age < 4 && (
              <p className="validEmail">Age must be at least 4 years.</p>
            )}

            {/* Age more than 50 */}
            {birthDate && age > 50 && age <= 100 && (
              <p className="validEmail">Age must be less than 50 years.</p>
            )}
            {/* No birth date after submit attempt */}
            {submitAttempted && !birthDate && (
              <p className="validEmail">Please Provide a Valid Date of Birth</p>
            )}
          </div>

          {/* Parent Information - ONLY shows when age < 18 */}
          {age < 18 && age >= 4 && birthDate !== "" && (
            <React.Fragment>
              <h3 className="text-center" style={{
                textAlign: "left",
                fontSize: "30px",
              }}>Parent Information</h3>
              {/* <p className="info-text">Since the student is under 18, we need parent/guardian information.</p> */}

              <div className="item">
                <div className="asterisk-group">
                  <h3>{`What is the Parent's Relationship to ${studentFirstName || "the Student"}?`}</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  className={`form-input ${submitAttempted && !parentRelationship ? 'error-border' : 'normal-border'}`}
                  name="parentRelationship"
                  value={parentRelationship}
                  onChange={(e) => onFormDataChange(e)}
                >
                  <option value="">Please Make a Selection</option>
                  <option value="Parent">Parent</option>
                  <option value="Guardian">Guardian</option>
                  <option value="Caregiver">Caregiver</option>
                </select>
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>{`What is ${studentFirstName === "" ? "the Student" : studentFirstName
                    }'s Parent's First Name?`}</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  maxLength="50"
                  autoCapitalize="0"
                  name="parentFirstName"
                  value={parentFirstName}
                  onChange={(e) => onFormDataChange(e)}
                  className={`form-input ${submitAttempted && !parentFirstName ? 'error-border' : 'normal-border'}`}

                />
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>{`What is ${studentFirstName === "" ? "the student" : studentFirstName
                    }'s Parent's Last Name?`}</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  maxLength="50"
                  autoCapitalize="0"
                  name="parentLastName"
                  value={parentLastName}
                  onChange={(e) => onFormDataChange(e)}
                  className={`form-input ${submitAttempted && !parentLastName ? 'error-border' : 'normal-border'}`}

                />
              </div>
            </React.Fragment>
          )}

          {/* Contact Information */}
           <h3 className="contact-info-title">Contact Info</h3>

          <div className="item">
            <div className="asterisk-group">
              <h3>{`What is ${age > 18 ||age===0
                ? studentFirstName + `'s Primary`
                : studentFirstName + "'s Parent's"
                } Email Address?`}</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="email"
              name="primaryEmail"
              value={primaryEmail}
              onChange={(e) => onFormDataChange(e)}
              className={`form-input ${submitAttempted && !primaryEmail ? 'error-border' : 'normal-border'}`}

            />
            {primaryEmail !== "" && !validateEmail(primaryEmail) && (
              <p className="validEmail">Please provide a valid email address</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
               <h3>{`What is ${age > 18|| age === 0
                ? studentFirstName + `'s Primary`
                : studentFirstName + "'s Parent's"
                } Phone Number?`}</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="12"
              name="phone"
              value={phone}
              onChange={(e) => formatPhoneNumber(e)}
              placeholder="XXX-XXX-XXXX"
              className={`form-input ${submitAttempted && !phone ? 'error-border' : 'normal-border'}`}

            />
            {phone !== "" && !validatePhone(phone) && (
              <p className="validEmail">
                Please Provide a Valid Phone Number in the Following Format XXX-XXX-XXXX
              </p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>ZIP/Postal Code</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="5"
              required
              name="zipCode"
              placeholder="XXXXX"
              value={zipCode}
              onChange={handleZipChange}
              className={`form-input ${submitAttempted && !zipCode ? 'error-border' : 'normal-border'}`}

            />
            {zipCode !== "" && !validatezipCode(zipCode) && (
              <p className="validEmail">
                Please Provide a Valid Zip/Postal Code in the Following Format XXXXX
              </p>
            )}
          </div>

          {/* Submit Button - Now inside the form box matching item width */}
          <div className="item submit-button-container">
            {!siteDataLoaded && siteId && (
              <p style={{ textAlign: 'center', color: '#666', marginBottom: '10px' }}>
                Loading site information...
              </p>
            )}
            <input
              type="submit"
              value={!siteDataLoaded && siteId ? "Loading..." : "Submit"}
              className={`btn btn-l4l-green enroll-btn submit-button ${!isFormValid ? 'disabled' : ''}`}
              onClick={onSubmit}              
            />
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};

export default InitialQuestions;